'use client';

import { useTranslations } from '@/i18n/use-translations';
import { useContext, useEffect } from 'react';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import Dialog from '@/components/Dialog';
import { useInView } from 'react-intersection-observer';
import useTrackEditPrescription from '../services/useTrackEditPrescription';

export interface PrescriptionCorrectionDialogProps {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

/**
 * 处方纠错确认对话框
 * 当用户未输入处方信息时，询问是否继续使用无处方镜片
 */
export default function PrescriptionCorrectionDialog({
  open,
  onCancel,
  onContinue,
}: PrescriptionCorrectionDialogProps) {
  const t = useTranslations('lens-process.prescriptionCorrectionDialog');
  const { deviceType } = useContext(ResponsiveContext);
  const isMobile = [EPlatform.ANDROID, EPlatform.IOS].includes(deviceType);
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const { trackExposeCorrectionDialog, trackClickCorrectionDialog } = useTrackEditPrescription();
  useEffect(() => {
    if (inView) {
      trackExposeCorrectionDialog();
    }
  }, [inView]);
  return (
    <Dialog
      okText={t('continue')}
      cancelText={t('cancel')}
      title={t('title')}
      open={open}
      onClose={() => {
        onCancel();
        trackClickCorrectionDialog('Cancel');
      }}
      onOk={() => {
        onContinue();
        trackClickCorrectionDialog('Continue');
      }}
      showCloseIcon={false}
    >
      <div
        className={`bg-white rounded-[16px] w-full mx-auto ${isMobile ? 'max-w-[90vw]' : ''}`}
        ref={ref}
      >
        <div className="text-center mb-8">
          <p
            className={`text-gray-600 leading-relaxed ${isMobile ? 'text-[14px]' : 'text-[16px]'}`}
          >
            {t('description')}
          </p>
        </div>
      </div>
    </Dialog>
  );
}
